/**
 * Asynchronously loads the component for UploadDataDetailsPage
 */

import { lazyLoad } from 'utils/loadable';

export const UploadDataDetailsPage = lazyLoad(
  () => import('./index'),
  module => module.UploadDataDetailsPage,
);
